import { Asset } from "..";

export interface AssetDomain extends Asset {

}